import React, {Component} from 'react';
import { Map, InfoWindow, GoogleApiWrapper, Marker } from 'google-maps-react';
import ImageAPI from "../classes/ImageAPI";
import { withTranslation } from 'react-i18next';


class SearchResultsMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      images: {}
    };

    this.imageAPI = new ImageAPI();

    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onMapClicked = this.onMapClicked.bind(this);

  }

  componentDidMount() {
    if (this.props.results.paging.self.href.includes('&page')) {
      this.props.removePaging();
    }
    this.props.results.map((result) => {
      if (!this.state.images['media_' + result.field_keyvisual.attributes.drupal_internal__mid]) {
        this.imageAPI.embedImage(result.field_keyvisual.attributes.drupal_internal__mid, 'contact_block_small_420x220').then((results) => {
          let images = this.state.images;
          images['media_' + result.field_keyvisual.attributes.drupal_internal__mid] = results.uri;
          this.setState(images);
        });
      }

    });
  }

  onMarkerClick(props, marker, e) {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: props.id
    });
  }


  onMapClicked(props){
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      })
    }
  };

  render() {
    let markers = [];
    let infowindows = [];
    let bounds = new this.props.google.maps.LatLngBounds();
    let iconMarker = new window.google.maps.MarkerImage(
      "/themes/thcb_base/assets/dist/images/map-marker.svg",
      null, /* size is determined at runtime */
      null, /* origin is 0,0 */
      null, /* anchor is bottom center of the scaled image */
      new window.google.maps.Size(35, 45)
    );


    this.props.results.filter((result) => {
      if (result.field_location_data && (result.field_location_data.latitude || result.field_location_data.longitude)) {
        return true;
      }
      return false;
    }).map((result) => {
      let showingInfoWindow = (this.state.showingInfoWindow === result.drupal_internal__nid);
      bounds.extend(new google.maps.LatLng(result.field_location_data.latitude, result.field_location_data.longitude));
      const marker_name = this.props.t('search_results_map.marker_current_location', 'Current location');
      markers.push(
        <Marker icon={iconMarker} id={result.drupal_internal__nid} position={{lat: result.field_location_data.latitude, lng: result.field_location_data.longitude}} onClick={this.onMarkerClick} name={marker_name}/>
      );

      infowindows.push(
        <InfoWindow marker={this.state.activeMarker} visible={showingInfoWindow}>
          <div className="maps-balloon">
            <div className="maps-balloon__image">
              <img src={this.state.images['media_' + result.field_keyvisual.attributes.drupal_internal__mid]}/>
            </div>
            <div className="maps-balloon__inner">
              <span className="label maps-balloon__label">{result.field_venue_type[0].attributes.name}</span>
              <h5 className="maps-balloon__title">{result.title}</h5>
              <div className="maps-balloon__meta">
                {result.field_location_data.address}<br/>
                {result.field_location_data.postal_code} {result.field_location_data.city}<br/>
              </div>
            </div>
          </div>
        </InfoWindow>
      );
    });
    return (
        <Map google={this.props.google}
             onClick={this.onMapClicked}
             style={{width:'100%'}}
             initialCenter={{
               lat: 52.0717018,
               lng: 4.2748492
             }}
             zoom={12}
             bounds={bounds}
        >
          {markers}
          {infowindows}
        </Map>
    )
  }
}

export default withTranslation()(GoogleApiWrapper({
  apiKey: 'AIzaSyA7jjdDa92buk4trtbqifD3pCaLz1eJzBA'
})(SearchResultsMap));
